import React from 'react';
import styled from 'styled-components';

import {
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	DialogContent,
	Typography,
	IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import BtnPrimary from './BtnPrimary';

const RootDialog = styled(Dialog)`
	.MuiBackdrop-root {
		background-color: rgba(0, 0, 0, 0.8);
	}

	.MuiPaper-root {
		background-color: ${(props) => props.theme.palette.blocks.cardWrapper.background};
	}

	.MuiDialogTitle-root {
		padding: 20px 20px 0 20px;
	}

	.MuiDialogContent-root {
		padding: 0 10px 0 20px;
		margin-right: 10px;
	}

	.MuiDialogActions-root {
		padding: 20px;
	}

	.MuiDialogTitle-root {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;

		h6 {
			font-size: 20px;
			text-transform: uppercase;
			font-weight: bold;
		}
	}

	.MuiIconButton-root {
		color: ${(props) => props.theme.palette.text.primary};
	}

	.MuiDialogActions-root {
		& > *:not(:first-child) {
			margin-left: 20px;
		}
	}

	.dialog__btn {
		text-transform: initial;
		font-size: 16px;
	}
`;

const DialogDefault = ({
	children,
	headline,
	openModal,
	closeModal,
	confirmButton,
	confirmButtonText = 'Speichern',
	showButtons = true,
	maxWidth,
}) => (
	<RootDialog open={openModal} onClose={closeModal} maxWidth={maxWidth}>
		<DialogTitle disableTypography>
			<Typography variant="h6">{headline}</Typography>
			<IconButton onClick={closeModal} aria-label="close">
				<CloseIcon />
			</IconButton>
		</DialogTitle>
		<DialogContent>{children}</DialogContent>
		{showButtons && (
			<DialogActions>
				<Button className="dialog__btn" onClick={closeModal}>
					Abbrechen
				</Button>
				<BtnPrimary className="dialog__btn" onClick={confirmButton}>
					{confirmButtonText}
				</BtnPrimary>
			</DialogActions>
		)}
	</RootDialog>
);

export default DialogDefault;
